// extracted by mini-css-extract-plugin
module.exports = {"step":"ReferFriendStep_step__IUwgz","content":"ReferFriendStep_content__TwhOS","stepNumber":"ReferFriendStep_stepNumber__9GbOl","description":"ReferFriendStep_description__ZsZs5"};